// extracted by mini-css-extract-plugin
export default {"wrapper":"Navbar_wrapper__4tmk8","logo":"Navbar_logo__aCJLp"};